import { AUTH_TOKEN_KEY, deleteCookie } from "../helpers/func"

export const Disconnect = () => {
    deleteCookie(AUTH_TOKEN_KEY);
    window.open("/login", '_self');
}